/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editpicturedescription2Inputs */

const en_editpicturedescription2 = /** @type {(inputs: Editpicturedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crop, scale and adjust an image in one editor.`)
};

const de_editpicturedescription2 = /** @type {(inputs: Editpicturedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild zuschneiden, skalieren und anpassen – alles in einem Editor.`)
};

/**
* | output |
* | --- |
* | "Crop, scale and adjust an image in one editor." |
*
* @param {Editpicturedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const editpicturedescription2 = /** @type {((inputs?: Editpicturedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editpicturedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_editpicturedescription2(inputs)
	return de_editpicturedescription2(inputs)
});
export { editpicturedescription2 as "editPictureDescription" }